import { ReduxService } from 'dashboard-services/services';

import { collectionsDatalakeActions } from 'actions/modules/datalake';

export const collectionsInitialState = {
  addSubsInputFile: undefined,
  addSubsInputFileRaw: undefined,
  addSubsInputFileInfo: undefined,
  addSubsConfiguration: undefined,
  addSubsMetadataNewFile: undefined,
  addSubsMetadataOverrideFile: undefined,
  addSubsMetadataValidationErrors: undefined,
}

export default (state = collectionsInitialState, action) => {
  switch (action.type) {
    case collectionsDatalakeActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case collectionsDatalakeActions.ON_CHANGE_SUBS_CONFIG: {
      if(state.addSubsConfiguration[action.itemIndex].fields[action.fieldIndex][action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          addSubsConfiguration: state.addSubsConfiguration.updateInList({ 
            fields: state.addSubsConfiguration[action.itemIndex].fields.updateInList({ [action.name]: action.value }, action.fieldIndex)
          }, action.itemIndex)
        })
      }
      return state;
    }
    case collectionsDatalakeActions.CLEAR:
      return collectionsInitialState;
    default:
      return state;
  }
}